export default "__VITE_ASSET__cd039975__"